

/**
 * @name MobileNavController
 * @description Controller for the mobile nav shelf
 * @param {object} Session The service delivering the user's session.
 */
function MobileNavController(
  Session
) {
  let vm = this;
  vm.session = Session;
}

angular
  .module('inkfinder')
  .controller('MobileNavController', MobileNavController);



// WEBPACK FOOTER //
// ./common/nav/mobile-nav.controller.js